var $ = require('jquery');
// flatpickr = require('flatpickr');
import flatpickr from 'flatpickr';

/**
 * Datepicker
 * Uses flatpicker plugin.
 * By default, is confiqured to 'wrap' + separate activation button to add extra accessibility, see markdown example from Movax Warranty activation form or
 * https://flatpickr.js.org/examples/#flatpickr-external-elements
 *
 *  @param {JQuery} element datepicker container
 */
class Datepicker {

  private $el;
  private $dateInput;
  private defaultSettings;

  constructor(element) {
    this.$el = $(element);
    this.$dateInput = this.$el.find('.datepicker__input');

    this.defaultSettings = {
      dateFormat: "d.m.Y",
      clickOpens: false,
      wrap: true,
      onReady: (selectedDates, dateStr, instance) => {
        //allow user to type directly to input
        this.$dateInput.removeAttr('readonly');
      }
    }

  }

  /**
   * Creates datepicker
   * @param {object} customsettings optional flatpicker config
   */
  createDatePicker(customsettings?) {
    let flatpickerElement = this.$el; //wrap mode uses container for init

    if(customsettings) {
      if(!customsettings.wrap) {
        flatpickerElement =  this.$dateInput;
      }
      flatpickr( flatpickerElement, customsettings);
    } else {
      //use default setup
      flatpickr( flatpickerElement, this.defaultSettings);
    }
  }

}

export {Datepicker};